(() => {
  const initialise = () => {
    document.querySelectorAll('[data-article-related-collection]').forEach((block) => {
      if (block.dataset.analyticsInitialised === 'true') return;
      block.dataset.analyticsInitialised = 'true';
      const link = block.querySelector('[data-article-related-collection-link]');
      if (!link) return;
      link.addEventListener('click', () => {
        const payload = {
          article_id: block.dataset.articleId || '',
          article_handle: block.dataset.articleHandle || '',
          article_title: block.dataset.articleTitle || '',
          article_url: window.location.pathname,
          page_location: window.location.href,
          placement: 'article_end',
          collection_id: block.dataset.collectionId || '',
          collection_handle: block.dataset.collectionHandle || '',
          destination_title: block.dataset.collectionTitle || link.textContent.trim(),
          destination_url: link.getAttribute('href') || '',
        };
        if (typeof window.tcgkingTrackArticleEvent === 'function') {
          window.tcgkingTrackArticleEvent('article_collection_click', payload);
        }
        if (!window.Shopify?.analytics?.publish) return;
        try {
          const result = window.Shopify.analytics.publish('tcgking:article_collection_click', payload);
          if (result?.catch) result.catch(() => {});
        } catch (_error) {
          // Analytics must never interrupt navigation.
        }
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise);
  else initialise();
})();
